import { toast } from "react-toastify";

const useNotification = () => {
  const showSuccessNotification = (message:string): void => {
    toast.success(message);
  };

  const showWarningNotification = (message: string): void => {
    toast.warn(message);
  };

  return {
    showSuccessNotification,
    showWarningNotification,
  };
};

export default useNotification;
